<div class="button">
  <a href="#" class="btn btn-primary {{class}}">
    <co-image *ngIf="icon" [width]="iconWidth" [height]="iconHeight" type="svg" [key]="icon" [imageSet]="imageSet" ></co-image>
    <span class="align-middle button-text">{{text}}</span>
  </a>
</div>